import React, { useState, useEffect } from 'react';
import SeoHelmet from '../components/SeoHelmet';

// SVG Icons
const Icons = {
  Distribution: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
    </svg>
  ),
  Publishing: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  ),
  Marketing: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
    </svg>
  ),
  Advisory: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895.356-1.754.988-2.386l-.548-.547z" />
    </svg>
  ),
  Branding: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  Sync: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  Booking: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
    </svg>
  ),
  Expertise: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
    </svg>
  ),
  Producers: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
    </svg>
  ),
  Connections: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  Versatility: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
    </svg>
  )
};

// Social Media Icons
const SocialIcons = {
  Instagram: () => (
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
    </svg>
  ),
  Twitter: () => (
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
    </svg>
  ),
  TikTok: () => (
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M19.589 6.686a4.793 4.793 0 01-3.77-4.245V2h-3.445v13.672a2.896 2.896 0 01-5.201 1.743l-.002-.001.002.001a2.895 2.895 0 113.183-4.51v-3.5a6.329 6.329 0 105.608 6.216 6.33 6.33 0 003.771-11.345z" />
    </svg>
  ),
  YouTube: () => (
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
    </svg>
  ),
  Spotify: () => (
    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-2-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" />
    </svg>
  ),
  Email: () => (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  Location: () => (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  )
};

const Services = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeService, setActiveService] = useState('distribution');
  
  // Contact form state
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, []);

  const services = {
    distribution: {
      title: 'Distribution',
      description: 'At Hi-Way 89 Entertainment, we ensure your music reaches every corner of the globe.',
      details: `We distribute your tracks to all major digital streaming platforms—including Spotify, Apple Music, Amazon Music, TikTok, YouTube Music, and 200+ other platforms worldwide. We also ensure that your royalties are tracked and paid on time.`,
      benefits: [
        'Global distribution to 200+ platforms',
        'Optimized metadata for maximum discoverability',
        'Transparent royalty tracking and timely payments',
        'Strategic release planning',
        'Priority playlist pitching'
      ],
      Icon: Icons.Distribution
    },
    publishing: {
      title: 'Publishing',
      description: 'At Hi-Way 89 Entertainment, we understand that the publishing side of music can be complex, and so we save you the stress and handle it for you.',
      details: `We ensure that your intellectual property is protected and you receive all royalties from performances, sales and placements. You focus on creating. We focus on making sure you get paid for it.`,
      benefits: [
        'Global copyright registration and protection',
        'Mechanical royalty collection',
        'Performance royalty tracking',
        'Publishing administration across all territories'
      ],
      Icon: Icons.Publishing
    },
    marketing: {
      title: 'Marketing',
      description: 'At Hi-Way 89, we help artists cut through the noise.',
      details: `Our marketing strategies are tailored to each artist's unique sound and goals. From social media campaigns and content creation to digital advertising and audience engagement, we craft tailored plans that align with your artistic vision and business objectives. We leverage our connections, not only in the African and Canadian markets, but also in the US and Europe, to create campaigns that resonate locally while building global appeal.`,
      benefits: [
        'Tailored marketing strategies',
        'Social media management and content creation',
        'Digital advertising campaigns (Meta, Google, TikTok)',
        'Audience analytics and growth strategies',
        'Strategic press campaigns and media outreach',
        'Influencer partnerships'
      ],
      Icon: Icons.Marketing
    },
    advisory: {
      title: 'Music Advisory',
      description: 'Here at Hi-Way 89, we understand the sensitivity of decision-making for artists at different stages of their careers.',
      details: `So we provide consultations and guidance that help them make informed decisions. From release strategies and royalty splits to choosing the right collaborations. We help you make the right move.`,
      benefits: [
        'Career strategy consultation',
        'Contract review and negotiation support',
        'Release strategy planning',
        'A&R guidance',
        'Industry connection facilitation',
        'Long-term career roadmapping'
      ],
      Icon: Icons.Advisory
    },
    branding: {
      title: 'Brand Partnerships',
      description: 'At Hi-Way 89, we understand that brand partnerships are not only about the money but also about building the right portfolio and reaching a win-win collaboration.',
      details: `This is why we ensure that artists connect with the right brands that align with their values and amplify their reach.`,
      benefits: [
        'Brand partnership opportunities',
        'Endorsement deal negotiations',
        'Sponsored tour support',
        'Product collaboration opportunities',
        'Long-term brand ambassadorships'
      ],
      Icon: Icons.Branding
    },
    sync: {
      title: 'Sync Placements',
      description: 'One well-placed sync can change everything, from generating significant income and exposure to literally transforming your career overnight.',
      details: `That is why we constantly pursue sync opportunities that your sound aligns with. Our team handles the pitching of your track to production companies and advertising agencies and helps your music find its way into TV shows, films, commercials, and more.`,
      benefits: [
        'Active pitching to music supervisors',
        'TV, film, and commercial placements',
        'Video game licensing opportunities',
        'Podcast and digital content sync',
        'Full rights clearance handling'
      ],
      Icon: Icons.Sync
    },
    booking: {
      title: 'Booking and Touring',
      description: 'At Hi-Way 89, we help artists take their music from streaming platforms to live stages.',
      details: `Our booking team secures performance opportunities ranging from intimate shows to major stages across Canada and Africa. We handle everything from negotiating performance fees and routing tours to coordinating logistics; we've got you covered.`,
      benefits: [
        'Live show bookings',
        'Tour routing and planning',
        'Performance fee negotiations',
        'International touring support',
        'Tour logistics and rider management'
      ],
      Icon: Icons.Booking
    }
  };

  const whyChooseUs = [
    {
      title: 'Industry Expertise',
      description: 'We have over a decade of combined experience in artist development in Canada and Africa. We have seen what works and what doesn\'t. We save you the struggle of handling it on your own.',
      Icon: Icons.Expertise
    },
    {
      title: 'Award-winning Producers & Global Collaborators',
      description: 'We have a team of producers and collaborators who are industry heavyweights and who have worked with global stars. This means you get access to world-class talent that can elevate your sound.',
      Icon: Icons.Producers
    },
    {
      title: 'Cross-Continental Connections',
      description: 'We\'re uniquely positioned as the bridge between Canadian and African music industries. Whether you\'re a Canadian artist looking to break into African markets or an African artist targeting North America, we\'ve got the connections to make it happen.',
      Icon: Icons.Connections
    },
    {
      title: 'Genre Fusion & Versatility',
      description: 'We work with artists across the full spectrum of music, from Afrobeats and amapiano to hip-hop, R&B, and pop.',
      Icon: Icons.Versatility
    }
  ];

  const howItWorks = [
    {
      step: '01',
      title: 'Get in Touch',
      description: 'Reach out to us through any of our contact details provided.'
    },
    {
      step: '02',
      title: 'Initial Consultation',
      description: 'Schedule a consultation to discuss your specific needs and create a tailored plan.'
    },
    {
      step: '03',
      title: 'Customised Service Plan',
      description: 'We\'ll develop a package that makes sense for where you are and where you want to be.'
    },
    {
      step: '04',
      title: 'Onboarding',
      description: 'We\'ll onboard you into our systems and develop your release strategy.'
    },
    {
      step: '05',
      title: 'Execution',
      description: 'Full throttle execution on set plans and strategy.'
    }
  ];

  const socialLinks = [
    {
      platform: 'Instagram',
      url: 'https://www.instagram.com/hiway89ent?igsh=Zm42ZjRtYmoyN3l4',
      Icon: SocialIcons.Instagram
    },
    {
      platform: 'Twitter',
      url: 'https://x.com/hiway89ent?s=21&t=W37y8xb6JUNjJS1xSpoj4Q',
      Icon: SocialIcons.Twitter
    },
    {
      platform: 'TikTok',
      url: 'https://www.tiktok.com/@hiway89ent?_r=1&_t=ZS-92RJZi3mFE2',
      Icon: SocialIcons.TikTok
    },
  ];

  const metadata = {
    title: 'Services | HI-WAY 89 - Music Label Services',
    description: 'Here\'s the truth: talent isn\'t the problem. Infrastructure is. At Hi-Way 89 Entertainment, we give artists the infrastructure to build careers that cross borders.',
    canonical: "/services"
  };

  const handleContactClick = () => {
    document.getElementById('contact-section').scrollIntoView({ behavior: 'smooth' });
  };

  // Contact form handler - CONNECTED TO BACKEND API
  const handleContactSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.name || !formData.email || !formData.message) {
      setSubmitStatus('❌ Please fill in all required fields');
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setSubmitStatus('❌ Please enter a valid email address');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('Sending message...');

    try {
      // Call the contact API endpoint - CONNECTED TO YOUR BACKEND
      const response = await fetch('https://hi-way-89-backend.onrender.com/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        setSubmitStatus('✅ Message sent! Check your email for confirmation.');
        // Reset form
        setFormData({
          name: '',
          email: '',
          service: '',
          message: ''
        });
      } else {
        setSubmitStatus(`❌ ${result.error || 'Failed to send message. Please try again.'}`);
      }
    } catch (error) {
      console.error('Contact form error:', error);
      setSubmitStatus('❌ Network error. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <>
      <SeoHelmet {...metadata} />

      <div className="min-h-screen bg-black text-white pt-28">
        {/* Hero Section */}
        <div className={`relative overflow-hidden transition-all duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <div className="container mx-auto px-6 py-12 md:py-24">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-5xl md:text-7xl lg:text-8xl font-black mb-6 tracking-tighter leading-tight">
                <span className="block">TALENT ISN'T</span>
                <span className="block text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">THE PROBLEM.</span>
              </h1>
              <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed">
                Here's the truth: talent isn't the problem. Infrastructure is.
              </p>
              <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed">
                You've got the music. You've got the drive. What you don't have is someone who can get your song on that playlist, book you on that big stage, or connect you with that producer who could change everything.
              </p>
              <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed">
                That's where we come in.
              </p>
              <p className="text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed">
                At Hi-Way 89 Entertainment, we've spent over a decade building the connections you need. We've developed several outstanding artists across Africa, Europe, the US, and Canada. We've worked with Grammy-winning producers. And we've done it by creating something most labels don't have: a real bridge between two of the world's most exciting music scenes.
              </p>
              <button
                onClick={handleContactClick}
                className="group relative px-12 py-4 bg-white text-black font-bold text-lg tracking-widest overflow-hidden transition-all duration-300 hover:bg-gray-100 transform hover:scale-105"
              >
                <span className="relative z-10">GET IN TOUCH</span>
                <div className="absolute inset-0 bg-gradient-to-r from-gray-200 to-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </button>
            </div>
          </div>
          
          {/* Gradient Overlay */}
        </div>

        {/* What We Offer Section */}
        <div className="container mx-auto px-6 py-20">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-black mb-6 tracking-tight">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">WHAT WE OFFER</span>
              </h2>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                We don't just sign artists; we give you the infrastructure to build a career that crosses borders.
              </p>
            </div>

            {/* Services Navigation */}
            <div className="flex flex-wrap justify-center gap-4 mb-12">
              {Object.keys(services).map((serviceKey) => (
                <button
                  key={serviceKey}
                  onClick={() => setActiveService(serviceKey)}
                  className={`px-6 py-3 font-medium text-sm tracking-widest transition-all duration-300 relative group ${
                    activeService === serviceKey
                      ? 'text-white bg-white/10'
                      : 'text-gray-400 hover:text-white hover:bg-white/5'
                  }`}
                >
                  <span className="relative z-10">{services[serviceKey].title}</span>
                  {activeService === serviceKey && (
                    <div className="absolute inset-0 border border-white/20"></div>
                  )}
                </button>
              ))}
            </div>

            {/* Active Service Details */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-24">
              <div className="space-y-8">
                <div className="flex items-center space-x-4">
                  <div className="text-gray-400 group-hover:text-white transition-colors duration-300">
                    {React.createElement(services[activeService].Icon)}
                  </div>
                  <div>
                    <h3 className="text-3xl font-black mb-2">{services[activeService].title}</h3>
                    <p className="text-xl text-gray-300">{services[activeService].description}</p>
                  </div>
                </div>
                <p className="text-gray-300 leading-relaxed text-lg">
                  {services[activeService].details}
                </p>
              </div>
              
              <div className="space-y-6">
                <h4 className="text-2xl font-bold border-l-4 border-white pl-4">WHAT YOU GET:</h4>
                <div className="grid gap-4">
                  {services[activeService].benefits.map((benefit, index) => (
                    <div key={index} className="flex items-start space-x-3 group cursor-pointer">
                      <div className="w-2 h-2 bg-white rounded-full mt-2 group-hover:scale-125 transition-transform duration-300"></div>
                      <span className="text-gray-300 group-hover:text-white transition-colors duration-300">{benefit}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Why Choose Us */}
            <div className="mb-24">
              <h2 className="text-4xl md:text-5xl font-black mb-12 text-center tracking-tight">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">WHY CHOOSE US</span>
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                {whyChooseUs.map((item, index) => (
                  <div key={index} className="group p-6 border border-gray-800 hover:border-white/30 transition-all duration-500 hover:bg-white/5">
                    <div className="text-gray-400 group-hover:text-white mb-4 transition-colors duration-300">
                      {React.createElement(item.Icon)}
                    </div>
                    <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                    <p className="text-gray-300 text-sm leading-relaxed">{item.description}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* CTA Section */}
            <div className="text-center py-16 border-t border-b border-gray-800 mb-24">
              <h2 className="text-4xl md:text-5xl font-black mb-6 tracking-tight">
                READY TO TAKE YOUR MUSIC CAREER GLOBAL?
              </h2>
              <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
                Whether you're an emerging artist grinding for your first break or an established act ready to go international.
              </p>
              <button
                onClick={handleContactClick}
                className="group relative px-12 py-4 bg-gradient-to-r from-white to-gray-200 text-black font-bold text-lg tracking-widest overflow-hidden transition-all duration-300 hover:from-gray-200 hover:to-white transform hover:scale-105"
              >
                <span className="relative z-10">LET'S TALK</span>
                <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </button>
            </div>

            {/* Contact Section - UPDATED WITH API INTEGRATION */}
            <div id="contact-section" className="pb-24">
              <h2 className="text-4xl md:text-5xl font-black mb-12 text-center tracking-tight">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">GET IN TOUCH</span>
              </h2>
              
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
                {/* Contact Form - UPDATED WITH API */}
                <div className="space-y-8">
                  <div>
                    <h3 className="text-2xl font-bold mb-6">SEND US A MESSAGE</h3>
                    <form onSubmit={handleContactSubmit} className="space-y-6">
                      <div>
                        <input
                          type="text"
                          name="name"
                          placeholder="Your Name *"
                          value={formData.name}
                          onChange={handleInputChange}
                          disabled={isSubmitting}
                          className="w-full px-4 py-3 bg-white/5 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:border-white transition-all duration-300 disabled:opacity-50"
                          required
                        />
                      </div>
                      <div>
                        <input
                          type="email"
                          name="email"
                          placeholder="Your Email *"
                          value={formData.email}
                          onChange={handleInputChange}
                          disabled={isSubmitting}
                          className="w-full px-4 py-3 bg-white/5 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:border-white transition-all duration-300 disabled:opacity-50"
                          required
                        />
                      </div>
                      <div>
                        <select 
                          name="service"
                          value={formData.service}
                          onChange={handleInputChange}
                          disabled={isSubmitting}
                          className="w-full px-4 py-3 bg-white/5 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:border-white transition-all duration-300 disabled:opacity-50"
                        >
                          <option value="">I'm interested in...</option>
                          <option value="distribution">Distribution</option>
                          <option value="marketing">Marketing</option>
                          <option value="publishing">Publishing</option>
                          <option value="advisory">Music Advisory</option>
                          <option value="branding">Brand Partnerships</option>
                          <option value="sync">Sync Placements</option>
                          <option value="booking">Booking & Touring</option>
                          <option value="full">Full Label Services</option>
                        </select>
                      </div>
                      <div>
                        <textarea
                          name="message"
                          placeholder="Tell us about your project or needs... *"
                          rows="4"
                          value={formData.message}
                          onChange={handleInputChange}
                          disabled={isSubmitting}
                          className="w-full px-4 py-3 bg-white/5 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:border-white transition-all duration-300 resize-none disabled:opacity-50"
                          required
                        ></textarea>
                      </div>
                      
                      {/* Status message */}
                      {submitStatus && (
                        <div className={`p-4 rounded ${submitStatus.includes('✅') ? 'bg-green-900/30 text-green-400 border border-green-800' : 'bg-red-900/30 text-red-400 border border-red-800'}`}>
                          {submitStatus}
                        </div>
                      )}
                      
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full px-8 py-4 bg-white text-black font-bold text-sm tracking-widest hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
                      >
                        {isSubmitting ? (
                          <span className="flex items-center justify-center">
                            <svg className="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                            </svg>
                            SENDING MESSAGE...
                          </span>
                        ) : 'SEND MESSAGE'}
                      </button>
                    </form>
                  </div>
                </div>

                {/* Contact Info */}
                <div className="space-y-8">
                  <div>
                    <h3 className="text-2xl font-bold mb-6">CONTACT DETAILS</h3>
                    <div className="space-y-6">
                      <div className="flex items-start space-x-4">
                        <div className="text-gray-400 mt-1">
                          <SocialIcons.Email />
                        </div>
                        <div>
                          <p className="text-sm text-gray-400 mb-1">EMAIL</p>
                          <p className="text-lg">admin@hi-way89.com</p>
                          <p className="text-gray-500 text-sm mt-1">For inquiries & submissions</p>
                        </div>
                      </div>
                      
                      <div className="flex items-start space-x-4">
                        <div className="text-gray-400 mt-1">
                          <SocialIcons.Location />
                        </div>
                        <div>
                          <p className="text-sm text-gray-400 mb-1">LOCATION</p>
                          <p className="text-lg">Canada • Worldwide</p>
                          <p className="text-gray-500 text-sm mt-1">Serving artists globally</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold mb-6">FOLLOW US</h3>
                    <div className="flex space-x-4">
                      {socialLinks.map((social) => (
                        <a
                          key={social.platform}
                          href={social.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="w-12 h-12 flex items-center justify-center border border-gray-700 text-gray-400 hover:text-white hover:border-white transition-all duration-300 transform hover:scale-110"
                          aria-label={social.platform}
                        >
                          {React.createElement(social.Icon)}
                        </a>
                      ))}
                    </div>
                  </div>

                  {/* What to Expect */}
                  <div className="bg-white/5 p-6 rounded-lg border border-gray-800">
                    <h3 className="text-xl font-bold mb-4">WHAT HAPPENS NEXT?</h3>
                    <div className="space-y-3">
                      <div className="flex items-start space-x-3">
                        <div className="w-6 h-6 rounded-full bg-white text-black flex items-center justify-center text-xs font-bold">
                          1
                        </div>
                        <p className="text-gray-300 text-sm">
                          You'll receive an email confirmation immediately
                        </p>
                      </div>
                      <div className="flex items-start space-x-3">
                        <div className="w-6 h-6 rounded-full bg-white text-black flex items-center justify-center text-xs font-bold">
                          2
                        </div>
                        <p className="text-gray-300 text-sm">
                          Our team reviews your submission within 24 hours
                        </p>
                      </div>
                      <div className="flex items-start space-x-3">
                        <div className="w-6 h-6 rounded-full bg-white text-black flex items-center justify-center text-xs font-bold">
                          3
                        </div>
                        <p className="text-gray-300 text-sm">
                          We schedule a consultation call to discuss your goals
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;